const OverViewIcon = ({ header }) => {
  const icon = (
    <svg
      width="48"
      height="48"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6 1.2C15.6 0.537258 15.0627 0 14.4 0H1.2C0.537258 0 0 0.537258 0 1.2V13.8C0 14.4627 0.537259 15 1.2 15H14.4C15.0627 15 15.6 14.4627 15.6 13.8V1.2ZM13.2 12.6V2.4H2.4V12.6H13.2Z"
        fill="#CCDBF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6 22.2C15.6 21.5373 15.0627 21 14.4 21H1.2C0.537258 21 0 21.5373 0 22.2V34.8C0 35.4627 0.537259 36 1.2 36H14.4C15.0627 36 15.6 35.4627 15.6 34.8V22.2ZM13.2 33.6V23.4H2.4V33.6H13.2Z"
        fill="#CCDBF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8 21C35.4627 21 36 21.5373 36 22.2V34.8C36 35.4627 35.4627 36 34.8 36H21.6C20.9372 36 20.4 35.4627 20.4 34.8V22.2C20.4 21.5373 20.9372 21 21.6 21H34.8ZM33.6 23.4V33.6H22.8V23.4H33.6Z"
        fill="#CCDBF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 1.2C36 0.537258 35.4627 0 34.8 0H21.6C20.9372 0 20.4 0.537258 20.4 1.2V13.8C20.4 14.4627 20.9372 15 21.6 15H34.8C35.4627 15 36 14.4627 36 13.8V1.2ZM33.6 12.6V2.4H22.8V12.6H33.6Z"
        fill="#CCDBF0"
      />
    </svg>
  );
  return (
    <>
      {icon}
      <span className="text-light-2 text-xs pt-2 font-scaniacondensed">
        {header}
      </span>
    </>
  );
};

export default OverViewIcon;
